import * as React from 'react';
import type { SVGProps } from 'react';

const IconTIApp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    {...props}
  >
    <rect width="80" height="80" rx="20" fill="#F32A52" />
    <path
      d="M21.3224 25.459H20.6934C20.6934 20.9444 20.6934 16.4899 20.6934 12C33.4919 12 46.2756 12 59.0934 12C59.0934 16.4727 59.0934 20.9273 59.0934 25.459C58.884 25.459 58.6865 25.459 58.4889 25.459C54.814 25.459 51.138 25.459 47.4631 25.459C46.7957 25.459 46.7935 25.459 46.7935 26.1274C46.7935 34.9012 46.7935 43.6751 46.7935 52.4489V53.2514C46.5575 53.1431 46.4048 53.0873 46.267 53.0068C42.0005 50.5253 37.7382 48.0373 33.4652 45.5665C33.1053 45.3584 32.9932 45.1202 32.9943 44.7147C33.006 38.5575 33.0039 32.4004 33.0017 26.2433C33.0017 25.3646 33.0701 25.4612 32.2467 25.4612C28.6049 25.4579 24.9642 25.4601 21.3224 25.4601V25.459ZM59.0934 54.5828C46.2788 54.5828 33.4973 54.5828 20.6934 54.5828C20.6934 59.0674 20.6934 63.5197 20.6934 68C33.5069 68 46.2894 68 59.0934 68C59.0934 63.5112 59.0934 59.0577 59.0934 54.5828Z"
      fill="white"
    />
  </svg>
);

export default IconTIApp;
